<template>
  <Header :showSteps="!isLoginRequired"></Header>

  <Login v-if="isLoginRequired"></Login>
  <UserInfo v-else-if="showUsers"></UserInfo>
  <template v-else-if="countries.length && basins.length && crops.length">
    <template v-if="assessment.step.name == 'scope'">
      <div v-if="assessment.branding == 'sbtn'" class="sbtn-header">
        <a href="https://sciencebasedtargetsnetwork.org/"><img src="./assets/img/logos/sbtn-logo-yellow.svg"/></a>
      </div>
      <Home></Home>
    </template>
    <Main v-else></Main>

    <div v-if="modal" @mousedown="mouseHandler" @mousemove="mouseHandler" @mouseup="mouseHandler" class="contra-modal"></div>
    <Modal v-if="modal" :modal="modal">
      <Country    v-if="modal.type == 'country'"  :modal="modal"></Country>
      <RiverBasin v-if="modal.type == 'basin'"    :modal="modal"></RiverBasin>
      <Crop       v-if="modal.type == 'crop'"     :modal="modal" :tempCrop="modal.tempCrop" :setCrop="modal.setCrop" :validate="modal.validate" :commit="modal.commit" :nextStep="modal.nextStep"></Crop>
      <Scenario   v-if="modal.type == 'scenario'" :modal="modal"></Scenario>
    </Modal>

    <template v-for="modal of modals" :key="modal.id">
      <div @mousedown="mouseHandler" @mousemove="mouseHandler" @mouseup="mouseHandler" class="contra-modal"></div>
      <Modal :modal="modal">
        <Crop                v-if="modal.type == 'crop'"                :modal="modal" :tempCrop="modal.tempCrop" :setCrop="modal.setCrop" :validate="modal.validate" :commit="modal.commit" :nextStep="modal.nextStep"></Crop>
      <Scenario            v-if="modal.type == 'scenario'"            :modal="modal"></Scenario>
      <Scenario1           v-if="modal.type == 'scenario1'"           :modal="modal" :tempScenario="modal.tempScenario"></Scenario1>
      <ScenarioCountryCrop v-if="modal.type == 'scenarioCountryCrop'" :modal="modal" :tempScenario="modal.tempScenario"></ScenarioCountryCrop>
      <ScenarioProcess     v-if="modal.type == 'scenarioProcess'"     :modal="modal"></ScenarioProcess>
      <Process             v-if="modal.type == 'process'"             :modal="modal" :tempScenario="modal.tempScenario"></Process>
    </Modal>
    </template>

    <tippy v-if="tippyLevel == 0" placement="bottom" toSelector=".header" @hide="understand(1)">
      <p>
        You have reached the <strong>Accounting</strong> step. In this step you can see the locations that you imported.
        If the locations of your business contain water footprint information, you will see that they differ in size.
        Press <strong>Sustainability</strong> to add water reduction targets to your locations.
      </p>
      <div class="understood">
        <a href="#" @click.prevent="understand(1)">[ understood ]</a>
      </div>
    </tippy>
    <tippy v-if="tippyLevel == 0" placement="bottom" toSelector=".btn-arrow.right">
      <p>
        Or use the <strong>Next step</strong> button.
      </p>
    </tippy>
    <tippy v-if="tippyLevel == 1" placement="left" toSelector=".view__item:not(.active)" @hide="understand(2)">
      <p>
        If the locations of your business contain water footprint information, you can see the water footprint per country in a <strong>bar chart</strong>.
      </p>
      <div class="understood">
        <a href="#" @click.prevent="understand(2)">[ understood ]</a>
      </div>
    </tippy>
    <tippy v-if="tippyLevel == 2" placement="left" toSelector=".view__item:not(.active)" @hide="understand(3)">
      <p>
        Press the <strong>Table view</strong> button to see the locations of your business in a table that can be downloaded.
      </p>
      <div class="understood">
        <a href="#" @click.prevent="understand(3)">[ understood ]</a>
      </div>
    </tippy>
  </template>
</template>

<script>
import { CenterScale, defaultFocusModel } from "vue-niney";
import RiverBasin from "@/components/modal/RiverBasin.vue";
import Country from "@/components/modal/Country.vue";
import Crop from "@/components/modal/Crop.vue";
import Header from "@/components/layout/Header.vue";
import Home from "@/views/Home.vue";
import Login from "@/components/layout/Login.vue";
import Main from "@/views/Main.vue";
import Modal from "./components/modal/Modal.vue";
import Scenario from "@/components/modal/Scenario.vue";
import Scenario1 from "@/components/modal/Scenario1.vue";
import ScenarioCountryCrop from "@/components/modal/ScenarioCountryCrop.vue";
import ScenarioProcess from "@/components/modal/ScenarioProcess.vue";
import Process from "@/components/modal/Process.vue";
import UserInfo from "./components/layout/UserInfo.vue";
import tippy from "@/components/shared/Tippy.vue";
import { assessment } from "@/services/assessment-model";
import { getBasin, getCountryByIso3Code,
  loadBaseEntities,
  countries,
  basins,
  crops,
  scenarioCountryCrops,
  countryCropsByCountryLoader,
  countryCropsByCropLoader,
  basinCropsByBasinLoader,
  basinCropsByCropLoader,
  countryBasinCropsLoader,
  scenariosLoader,
  t
} from "@/services/entity-model.js";
import { modals } from "@/services/modal-model";
import { userModel } from "@/services/user-model";

const homeModals = {
  country:  { id: 1,                                                                                                         width: 650, type: "country" },
  basin:    { id: 2,                                                                                                         width: 650, type: "basin" },
  crop:     { id: 3, validate: crop => (!crop || (crop.level < 3)) ? "No crop or material selected." : null, nextStep: true, width: 650, type: "crop" },
  scenario: { id: 4,                                                                                                         width: 700, type: "scenario" }
};

export default {
  name: "App",
  components: {
    RiverBasin,
    Country,
    Crop,
    Header,
    Home,
    Login,
    Main,
    Modal,
    Scenario,
    Scenario1,
    ScenarioCountryCrop,
    ScenarioProcess,
    Process,
    UserInfo,
    tippy
  },
  data() {
    return {
      modals,
      countries,
      basins,
      crops,
      scenarioCountryCrops,
      userModel,
      assessment,
      ignoreUrlChanges: false,
      understandingLevel: 0,
      tippyLevel: null
    };
  },
  created: function() {
    defaultFocusModel.minScale = 3466752.130657345;
    defaultFocusModel.setCenterScale(new CenterScale(0, 3000000, 110936068.18103503));

    loadBaseEntities();
    countryCropsByCropLoader.load(100001);
    basinCropsByCropLoader.load(100001);
  },
  methods: {
    mouseHandler() {
      // Catch all mouse events away for the modal.
    },
    updateAssessmentByUrl: function() {
      if ((this.countries.length == 0) || (this.basins.length == 0) || (this.crops.length == 0)) {
        return;
      }
      if (this.ignoreUrlChanges) {  // URL change was caused by a model change, so don't update assessment.
        this.ignoreUrlChanges = false;
        return;
      }

      assessment.branding = this.$route.query.b || "wfn";
      
      const params = Object.values(this.$route.params);
      if (params.length > 0) {
        assessment.setAssessmentType(params[0]);
        
        if (params.length > 1) {
          if (params[1].indexOf("~") == -1) {
            params.splice(1, null, null);
          } else {
            const codes = params[1].substr(1).split("~");
            if (assessment.assessmentType.name == "countries") {
              assessment.setCountriesOrBasins(codes.map(code => getCountryByIso3Code(code)));
            } else if (assessment.assessmentType.name == "basins") {
              assessment.setCountriesOrBasins(codes.map(code => getBasin(parseInt(code))));
            } else {  // assessment.assessmentType.name == "commodity" || "business"
              assessment.setCountriesOrBasins(codes.slice(1).map(code => getCountryByIso3Code(code)));
              if ((t.token == null) && (assessment.branding != "sbtn")) {
                assessment.setScenario({code: codes[0], name: "Waiting..."}, false);  // Temporarily set a dummy scenario while waiting for the user to login.
              } else {
                assessment.setScenario({code: codes[0], name: "Loading..."}, false);  // Temporarily set a dummy scenario while loading the scenario.
                scenariosLoader.load(codes[0], scenarios => assessment.setScenario(scenarios.filter(scenario => ((assessment.assessmentType.name == "commodity") && (scenario.type % 10 == 1)) || ((assessment.assessmentType.name == "business") && (scenario.type % 100 >= 10)))[0]));
              }
            }
          }
          assessment.setStep(params[2]);
          
          if (params.length > 3) {
            assessment.setViewType(params[3]);
            
            if (params.length > 4) {
              assessment.setViewColor(params[4]);
              
              if (params.length > 5) {
                assessment.setCrop(parseInt(params[5]));
              } else {
                assessment.setCrop(null);
              }
            }
          }
        }
      } else {
        assessment.setAssessmentType(null);
      }
    },
    updateUrlByAssessment: function() {
      let route = "/";
      if (assessment.assessmentType != null) {
        route += assessment.assessmentType.name;

        if ((assessment.scenario != null) || (assessment.countriesOrBasins.length > 0)) {
          route += "/";
          if (assessment.scenario != null) {
            route += "~" + assessment.scenario.code;
          }
          if (assessment.countriesOrBasins.length > 0) {
            if (assessment.assessmentType.name == "basins") {
              for (const basin of assessment.countriesOrBasins) {
                route += "~" + basin.basinID;
              }
            } else {
              for (const country of assessment.countriesOrBasins) {
                route += "~" + country.iso3Code;
              }
            }
          }
        }
        route += "/" + assessment.step.name;

        if (assessment.viewType != null) {
          route += `/${assessment.viewType.name}/${assessment.viewColor}`;
          
          if (assessment.crop != null) {
            route += `/${assessment.crop.cropID}`;
          }
        }
      }
      if (assessment.branding != "wfn") {
        route += "?b=" + assessment.branding;
      }
      if (this.$route.fullPath != route) {
        this.ignoreUrlChanges = true;
        if (!this.assessment.refresh) {
          this.$router.replace(route);
        } else {
          this.assessment.refresh = false;
          this.$router.push(route);
        }
      }
    },
    setTippyLevel() {
      this.tippyLevel = null;
      if (this.assessment.assessmentType && this.assessment.assessmentType.name == "business") {
        if ((this.assessment.step.name == "accounting") && (this.assessment.viewType.name == "map")) {
          if (this.understandingLevel <= 1) {
            setTimeout(() => this.tippyLevel = this.understandingLevel);
          }
        } else if ((this.assessment.step.name == "sustainability") && (this.assessment.viewType.name == "map")) {
          if (this.understandingLevel <= 2) {
            this.understandingLevel = 2;
            setTimeout(() => this.tippyLevel = this.understandingLevel);
          }
        }
      }
    },
    understand(understandingLevel) {
      this.understandingLevel = understandingLevel;
      this.setTippyLevel();
    }
  },
  computed: {
    isLoginRequired() {
      return (userModel.user === false) || (!userModel.user && assessment.isProduction() && (assessment.branding != "sbtn"));
    },
    showUsers() {
      return (userModel.users != null);
    },
    modal() {
      if (assessment.assessmentType == null) {
        return null;
      }
      if ((assessment.assessmentType.name == "countries") && (assessment.countriesOrBasins.length == 0)) {
        return homeModals.country;
      }
      if ((assessment.assessmentType.name == "basins") && (assessment.countriesOrBasins.length == 0)) {
        return homeModals.basin;
      }
      if ((assessment.assessmentType.name == "crops") && (assessment.crop == null)) {
        return homeModals.crop;
      }
      if ((assessment.assessmentType.name == "commodity" || assessment.assessmentType.name == "business") && (assessment.scenario == null)) {
        return homeModals.scenario;
      }
      return null;
    },
    countriesOrBasinsAndCrop() {
      return { countriesOrBasins: this.assessment.countriesOrBasins, crop: this.assessment.crop };
    },
    assessmentCopy() {
      return { a: this.assessment.assessmentType, b: this.assessment.step, c: this.assessment.viewType, d: this.assessment.viewColor, e: this.assessment.countriesOrBasins, f: this.assessment.crop, g: this.assessment.scenario };
    }
  },
  watch: {
    assessmentCopy: {
      handler: function(val) {
        this.updateUrlByAssessment();
      },
      deep: true
    },
    "assessment.assessmentType": function() {
      this.setTippyLevel();
    },
    "assessment.step": function() {
      this.setTippyLevel();
    },
    "assessment.viewType": function() {
      this.setTippyLevel();
    },
    countries: {
      handler: function() {
        this.updateAssessmentByUrl();
      },
      deep: true
    },
    basins: {
      handler: function() {
        this.updateAssessmentByUrl();
      },
      deep: true
    },
    crops: {
      handler: function() {
        this.updateAssessmentByUrl();
      },
      deep: true
    },
    "userModel.user.token": function() {
      if (assessment.scenario?.name == "Waiting...") {
        assessment.setScenario({code: assessment.scenario.code, name: "Loading..."}, false);  // Temporarily set a dummy scenario while loading the scenario.
        scenariosLoader.load(assessment.scenario.code, scenarios => assessment.setScenario(scenarios.filter(scenario => ((assessment.assessmentType.name == "commodity") && (scenario.type % 10 == 1)) || ((assessment.assessmentType.name == "business") && (scenario.type % 100 >= 10)))[0]));
      }
    },
    scenarioCountryCrops: {
      handler: function(val) {
        if (assessment.countriesOrBasins.length > 0) {
          const countryIdsHash = {};
          val.forEach(scenarioCountryCrop => countryIdsHash[scenarioCountryCrop.countryId] = true);
          const countryIds = Object.keys(countryIdsHash);
          if ((countryIds.length < 2) || !countryIds.includes(assessment.countriesOrBasins[0].countryID)) {
            assessment.setCountriesOrBasins([]);
          }
        }
      },
      deep: true
    },
    $route: function() {
      this.updateAssessmentByUrl();
    },
    countriesOrBasinsAndCrop: {
      handler: function(val) {
        const urlParams = {countryID: null, basinID: null, cropID: val.crop?.cropID || 100001};
        if (val.countriesOrBasins.length > 0) {
          const idPropertyName = this.assessment.assessmentType.idPropertyName;
          urlParams[idPropertyName] = val.countriesOrBasins.map(o => o[idPropertyName]).sort().join(",");
        }
        countryBasinCropsLoader.load(urlParams.countryID, urlParams.basinID, urlParams.cropID);
      },
      deep: true
    },
    "assessment.countriesOrBasins": function(val) {
      if (!val || val.length < 1) {
        return;
      }

      if (assessment.assessmentType.name === 'countries') {
        countryCropsByCountryLoader.load(val[0].countryID);
      }
      if (assessment.assessmentType.name === 'basins') {
        basinCropsByBasinLoader.load(val[0].basinID);
      }
    },
    "assessment.crop": function(val) {
      countryCropsByCropLoader.load(val?.cropID || 100001);
      basinCropsByCropLoader.load(val?.cropID || 100001);
    }
  }
};
</script>

<style lang="scss">
.contra-modal {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 6;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
}

.sbtn-header {
  margin: 0 -500px 0 -500px;
  padding: 15px 0 15px 0;
  text-align: center;
  background-color: #243c56;
  img {
    width: 420px;
  }
}

$font-family-sans-serif: "Open Sans";
$body-color: #301948;
$primary: #009bd1;
$secondary: #41b883;
$orange: #e45a00;
$min-contrast-ratio: 2.4;
$table-bg: none;
@import "bootstrap/scss/bootstrap";

$fa-font-path: "~@fortawesome/fontawesome-free/webfonts";
@import "@fortawesome/fontawesome-free/scss/fontawesome";
@import "@fortawesome/fontawesome-free/scss/solid";

/* latin-ext */
@font-face {
  font-family: 'Open Sans';
  font-style: italic;
  font-weight: 300;
  font-stretch: 100%;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/opensans/v43/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWt06F15M.woff2) format('woff2');
  unicode-range: U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: 'Open Sans';
  font-style: italic;
  font-weight: 300;
  font-stretch: 100%;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/opensans/v43/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWuU6F.woff2) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
/* latin-ext */
@font-face {
  font-family: 'Open Sans';
  font-style: italic;
  font-weight: 400;
  font-stretch: 100%;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/opensans/v43/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWt06F15M.woff2) format('woff2');
  unicode-range: U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: 'Open Sans';
  font-style: italic;
  font-weight: 400;
  font-stretch: 100%;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/opensans/v43/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWuU6F.woff2) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
/* latin-ext */
@font-face {
  font-family: 'Open Sans';
  font-style: italic;
  font-weight: 600;
  font-stretch: 100%;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/opensans/v43/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWt06F15M.woff2) format('woff2');
  unicode-range: U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: 'Open Sans';
  font-style: italic;
  font-weight: 600;
  font-stretch: 100%;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/opensans/v43/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWuU6F.woff2) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
/* latin-ext */
@font-face {
  font-family: 'Open Sans';
  font-style: italic;
  font-weight: 700;
  font-stretch: 100%;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/opensans/v43/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWt06F15M.woff2) format('woff2');
  unicode-range: U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: 'Open Sans';
  font-style: italic;
  font-weight: 700;
  font-stretch: 100%;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/opensans/v43/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWuU6F.woff2) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
/* latin-ext */
@font-face {
  font-family: 'Open Sans';
  font-style: italic;
  font-weight: 800;
  font-stretch: 100%;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/opensans/v43/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWt06F15M.woff2) format('woff2');
  unicode-range: U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: 'Open Sans';
  font-style: italic;
  font-weight: 800;
  font-stretch: 100%;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/opensans/v43/memtYaGs126MiZpBA-UFUIcVXSCEkx2cmqvXlWqWuU6F.woff2) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
//* latin-ext */
@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 300;
  font-stretch: 100%;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/opensans/v43/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTSGmu1aB.woff2) format('woff2');
  unicode-range: U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 300;
  font-stretch: 100%;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/opensans/v43/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTS-muw.woff2) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
/* latin-ext */
@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-stretch: 100%;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/opensans/v43/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTSGmu1aB.woff2) format('woff2');
  unicode-range: U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-stretch: 100%;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/opensans/v43/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTS-muw.woff2) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
//* latin-ext */
@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-stretch: 100%;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/opensans/v43/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTSGmu1aB.woff2) format('woff2');
  unicode-range: U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-stretch: 100%;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/opensans/v43/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTS-muw.woff2) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
/* latin-ext */
@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 700;
  font-stretch: 100%;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/opensans/v43/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTSGmu1aB.woff2) format('woff2');
  unicode-range: U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 700;
  font-stretch: 100%;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/opensans/v43/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTS-muw.woff2) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
/* latin-ext */
@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 800;
  font-stretch: 100%;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/opensans/v43/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTSGmu1aB.woff2) format('woff2');
  unicode-range: U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 800;
  font-stretch: 100%;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/opensans/v43/memvYaGs126MiZpBA-UvWbX2vVnXBbObj2OVTS-muw.woff2) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}

@font-face {
  font-family: "rubrikregular";
  src: url("./assets/fonts/rubrik_regular-webfont.eot");
  src: url("./assets/fonts/rubrik_regular-webfont.eot?#iefix") format("embedded-opentype"), url("./assets/fonts/rubrik_regular-webfont.woff") format("woff"), url("./assets/fonts/rubrik_regular-webfont.ttf") format("truetype"), url("./assets/fonts/rubrik_regular-webfont.svg#rubrik_regularregular") format("svg");
  font-weight: normal;
  font-style: normal;
}

html {
  height: 100%;
}
body {
  height: 100%;
  overflow-x: hidden;
  div#app {
    display: flex;
    height: 100%;
    flex-direction: column;
  }
}
h1, h2 {
  font-weight: 700;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s ease-in-out;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}
.lottie {
    position: absolute;
    left: 50%;
    top: 50%;
    z-index: 99999;
    border: solid 4px #edebe5;
    border-radius: 54px;
    background-color: #6db3a2;
    transform: translate(-50%, -50%);
}

.introduction-text {
  margin: 20px 0 30px 0;
  font-family: "rubrikregular";
  font-size: 18px;
  line-height: 27px;
}

.chart-axis-label {
  font-family: Arial, Helvetica, sans-serif;
  text-align: right;
}

.chart-tooltip {
  font-size: 15px;
  font-family: Arial, Helvetica, sans-serif;
  padding: 5px;
  color: #fff;
  background: rgba(0, 0, 0, 0.8);

  p {
    margin-bottom: 8px;
  }
}

.multiselect {
    min-height: 38px;
    color: inherit;
    &__tags {
      min-height: 38px;
      padding: 6px 12px;
      border-color: var(--bs-secondary);
      font-size: 16px;
    }
    &__input, &__single {
      margin-bottom: 0;
      padding: 0;
      line-height: 24px;
    }
    &__placeholder {
      margin-bottom: 0;
      padding-top: 0;
      color: var(--bs-secondary);
    }
    &__option {
      line-height: 13px;
      min-height: 30px;
      font-size: 13px;
    }
}

.wt-container {
    display: flex;
    flex-grow: 1;
    padding: 0 8%;
    overflow: scroll;
    flex-direction: column;
    // background: #cccccc; /* Old browsers */
    // background: -moz-linear-gradient(top,  #cccccc 0%, #ececec 100%); /* FF3.6-15 */
    // background: -webkit-linear-gradient(top,  #cccccc 0%,#ececec 100%); /* Chrome10-25,Safari5.1-6 */
    // background: linear-gradient(to bottom,  #cccccc 0%,#ececec 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    // filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#cccccc', endColorstr='#ececec',GradientType=0 ); /* IE6-9 */
}

.btn-primary {
    min-width: 75px;
    border-radius: 8px;
}
.btn-secondary {
    min-width: 50px;
    border-radius: 8px;
}
.button {
    background-color: #009bd1;
    color: white;
    padding: 10px 40px;
    border: none;
    border-radius: 8px;
    &:hover {
      background-color: #41b883;
    }

    img {
      width: 30px;
      margin-right: 15px;
    }
}
.table {
    margin-bottom: 0;
    td {
      vertical-align: middle;
      img {
        width: 20px;
        height: 20px;
      }
    }
}

.content {
    position: relative;
}

a {
  &:hover {
    color: #41b883;
  }
}

.tippy-popper {
  .tippy-tooltip {
    padding: 0;
    background-color: var(--bs-orange);
    font-size: inherit;
    line-height: inherit;
    text-align: inherit;
    .tippy-content {
      padding: 0;
    }
    p {
      margin: 0;
      padding: 18px;
    }
    .understood {
      border: 1px solid var(--bs-orange);
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
      padding: 5px 10px;
      background-color: white;
      text-align: right;
    }
  }
  &[x-placement^="top"] .tippy-arrow {
    border-top-color: var(--bs-orange);
  }
  &[x-placement^="right"] .tippy-arrow {
    border-right-color: var(--bs-orange);
  }
  &[x-placement^="bottom"] .tippy-arrow {
    border-bottom-color: var(--bs-orange);
  }
  &[x-placement^="left"] .tippy-arrow {
    border-left-color: var(--bs-orange);
  }
}
</style>
